import { FC } from 'react'
import AvailableModuleForm from './AvailableModuleForm'
import { ViewModuleProps } from './AvailableModule.d'

const ViewModule: FC<ViewModuleProps> = ({
    code,
    postFormSubmit,
    btnLabel,
    btnVariant,
    btnClassName,
}) => {
    return (
        <AvailableModuleForm
            code={code}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Module updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update module',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating module...',
                },
                triggerBtnLabel: btnLabel,
                triggerBtnVariant: btnVariant,
                triggerBtnClassName: btnClassName,
            }}
            postFormSubmit={() =>
                postFormSubmit ? postFormSubmit() : undefined
            }
        />
    )
}

export default ViewModule
